
import moment from 'moment';
import { Vue, Options, prop } from 'vue-class-component';

class Props {
  expiredDate = prop<string>({
    default: "",
  });
}

@Options({})
class Timer extends Vue.with(Props) {
  intervalId: any = null;
  timer = "";

  mounted() {
    this.intervalId = setInterval(() => {
      const now = moment();
      const expiredDate = moment(this.expiredDate)

      const diff = expiredDate.diff(now)
      if (diff > 0) {
        this.timer = moment(diff).format("mm:ss")
      } else this.timer = "00:00"
    }, 100)
  }

  unmounted() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}
export default Timer;
